import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-card',
  templateUrl: './loader-card.component.html',
  styleUrls: ['./loader-card.component.scss']
})
export class LoaderCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
